
import { GAMETYPE_ID, Season } from "@/models/GameType";
import { isEqual, cloneDeep } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ImageBox from "../../Base/ImageBox.vue";
import ImageSelector from "../../Base/ImageSelector.vue";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: {
    ImageSelector,
    ImageBox,
  },
})
class GameTypeGeneral extends Vue {
  @Prop({ default: "EN" }) readonly languageID!: string;
  @Prop({ default: null }) readonly seasonData!: Season;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  showSavePanel = false;
  seasonDataObject = {} as Season;
  showImageSelectorBool = false;

  get maxSpinnerSize(): string {
    return "6";
  }
  get getImage(): string {
    if (this.seasonData.imgs === undefined) {
      return "";
    } else {
      return this.seasonData.imgs[0];
    }
  }
  get getSavePanelLock(): boolean {
    if (this.isSavedOrDiscard) {
      this.showSavePanel = false;
      return false;
    } else {
      return this.showSavePanel;
    }
  }

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.MANHUNT;
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/img/misc/"
    );
  }

  created(): void {
    this.$store.dispatch("mapPoiStore/getMiniGameStyle", {
      type: "quest",
      name: "smurfs_2023",
    });
    if (this.seasonData.notes === undefined) {
      this.seasonData.notes = { en: "" };
      this.onValueChanged();
    }
    this.seasonDataObject = cloneDeep(this.seasonData);
  }
  showImageSelector(): void {
    if (!this.isEditingLocked) {
      this.showImageSelectorBool = true;
    }
  }
  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }
  returnImagePath(path: string): void {
    this.seasonData.imgs = [this.getImagePath + "" + path];

    this.onValueChanged();
    this.showImageSelectorBool = false;
  }
  onValueChanged(): void {
    var data = {
      type: "General",
      seasonData: this.seasonData,
      selectable: true,
    };
    if (!isEqual(this.seasonData, this.seasonDataObject)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", data);
  }
  @Watch("isEditingLocked")
  onIsEditingLockedChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }
  clearImage(): void {
    if (!this.isEditingLocked) {
      this.seasonData.imgs.splice(0, 1);
      this.onValueChanged();
    }
  }
  @Watch("seasonData", { deep: true })
  onPropertyChanged(): void {
    if (this.seasonData.notes === undefined) {
      this.seasonData.notes = { en: "" };
      this.onValueChanged();
    }

    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  @Validations()
  validations = {
    seasonData: {
      name: {
        en: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(160),
        },
      },
    },
  };
}

export default GameTypeGeneral;
